import 'lazysizes';

(function () {
    // if the config doesn't work see:
    // https://github.com/aFarkas/lazysizes/issues/410
    window.lazySizesConfig = window.lazySizesConfig || {};
    // see https://github.com/aFarkas/lazysizes#js-api---options
    window.lazySizesConfig = {
        lazyClass: 'lazyload',
        loadedClass: 'lazyloaded',
        loadingClass: 'lazyloading',
        preloadClass: 'lazypreload',
        errorClass: 'lazyerror',
        autosizesClass: 'lazyautosizes',
        srcAttr: 'data-src',
        srcsetAttr: 'data-srcset',
        sizesAttr: 'data-sizes',
        expand: 300,
        minSize: 40,
        init: true,
        expFactor: 1.5,
        hFac: 0.6,
        loadMode: 2,
        loadHidden: true,
        ricTimeout: 0,
        throttleDelay: 125
    }
})();
